"use strict";var e;Object.defineProperty(exports,"__esModule",{value:!0}),exports.WhitelabelScope=void 0,(e=exports.WhitelabelScope||(exports.WhitelabelScope={})).Brandfolder="",e.Getty="getty";
//# sourceMappingURL=whitelabel.js.map
